import { render, staticRenderFns } from "./VIPCenter.vue?vue&type=template&id=48e39f6c&scoped=true"
import script from "./VIPCenter.vue?vue&type=script&lang=js"
export * from "./VIPCenter.vue?vue&type=script&lang=js"
import style0 from "./VIPCenter.vue?vue&type=style&index=0&id=48e39f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e39f6c",
  null
  
)

export default component.exports